import React, { useState, Fragment, useEffect } from 'react';
import { Tooltip } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import categoryBotResponseCodeMapping from '../../../../../../data/categoryBotResponseCodeMapping';
import drBotResponseCodeMapping from '../../../../../../data/drBotResponseCodeMapping';
import accoBotResponseCodeMapping from '../../../../../../data/accoBotResponseCodeMapping';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  FormGroup,
} from 'reactstrap';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import {
  AxiosAPI,
  getUserID,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_By_Id,
  gAPI_Users_By_Id,
  gAPI_Vouchers_List,
  postAPI_Create_Messenger,
  gAPI_Messenger_By_Id,
  putAPI_Update_Messenger,
  putAPI_Delete_Messenger,
  gAPI_FormsBy_PropertyId,
  gAPI_QuestionSets
} from '../../../../../../constants/APIs';
import ImageGallery from '../../gallery/index';
import IconGallery from '../../icon-gallery/index';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faEdit } from '@fortawesome/free-solid-svg-icons';
import {
  categoriesData,
  salonCategoriesData,
  AccommodationCategoriesData,
  DoctorServicesCategoriesData,
  GuestServicesCategoriesData
} from '../../../../../../data/ServiceCategories';
import CategoryLayouts from '../../../../../../data/CategoryLayouts';
import CategoryTag from './CategoryTag';
import Appearance from './Appearance';
import Validation from '../../../../../../components/Validation';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};
const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
const guestLifeCycleList = [
  { label: 'Pre Booking', value: 'Pre Booking' },
  { label: 'Pre Check-in', value: 'Pre Check-in' },
  { label: 'At Property', value: 'At Property' },
  { label: 'After Check-out', value: 'After Check-out' },
  { label: 'Member Specific', value: 'Member Specific' }
];
const suitabilityData = [
  { label: 'Business Traveler', value: 'Business Traveler', key: 0 },
  { label: 'Vacationing Families', value: 'Vacationing Families', key: 1 },
  { label: 'Couples', value: 'Couples', key: 2 },
  { label: 'Solo Traveler', value: 'Solo Traveler', key: 3 },
  { label: 'Friends or a Group', value: 'Friends or a Group', key: 4 },
];
export function AddNewMessenger({
  id,
  visible,
  toggleModal,
  formLabel,
  isServiceOrder,
  propertyId,
  domains,
  isHostedPage,
  locale,
  allAddonCategoryData,
  allMembershipGroupData,
  LoadData,
  languageCode,
  productCategorydata
}) {
  const [titleToolTip, settitleToolTip] = useState(false);
  const [typeToolTip, setTypeToolTip] = useState(false);
  const [priceToolTip, setpriceToolTip] = useState(false);
  const [categoryToolTip, setCategoryToolTip] = useState(false);
  const [globelToolTip, setGlobelToolTip] = useState(false);
  const [selectedOptions, setselectedOptions] = useState([]);
  const [selectedcategories, setselectedcategories] = useState([]);
  const [isDoctor, setIsDoctor] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [svgGalleryVisible, setSvgGalleryVisible] = useState(false);
  const [qbot, setQbot] = useState(false);
  const [isAccommodation, setIsAccommodation] = useState(false);
  const [isBusinessOperator, setIsBusinessOperator] = useState(false);
  const [selectedSuitability, setSelectedSuitability] = useState([]);
  const [lifeCycle, setLifeCycle] = useState(guestLifeCycleList);
  const [isAivaProperty, setIsAivaProperty] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [guestServiceCategory, setGuestServiceCategory] = useState(GuestServicesCategoriesData);
  const [addTagModel, setAddTagModel] = useState(false);
  const [ownTag, setOwnTag] = useState('');
  const [addonCategoryData, setAddonCategoryData] = useState([
    { label: 'Add New', value: 'Add own tag', key: -1, }
  ]);
  const [membershipGroupData, setMembershipGroupData] = useState([
    { label: 'Add New', value: 'Add own tag', key: -1, }
  ]);
  const [selectedMembershipGroup, setSelectedMembershipGroup] = useState([]);
  const [isCategoryTag, setIsCategoryTag] = useState(false);
  const [isMembershipGroup, setIsMembershipGroup] = useState(false);
  const [formsData, setFormsData] = useState([]);
  const [addCategoryTagModel, setAddCategoryTagModel] = useState(false);
  const [isEditCategory, setIsEditCategory] = useState(false);
  const [errorModel, setErrorModel] = useState({ isVisible: false, msg: "" });
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [conversationFlowList, setConversationFlowList] = useState([]);

  const [isIframe, setIsIframe] = useState(false);
  const [isIframeTop, setIsIframeTop] = useState(false);

  const [selectedTypeCategory, setSelecetdTypeCategory] = useState([]);
  const [productCategory, setProductCategory] = useState(productCategorydata);
  const typeTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service</b> is one service like Dental Exam & Xray.
          <br /> <b>Package </b> is a service bundle offering multiple services
          for sale as a one combined service package.
          <br /> <b>Special Offer </b> is certain special value you can offer to
          your client.
        </Tooltip>
      );
    } else if (qbot) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Room Service</b> is a food or beverage order that a guest can place
          to be delivered to the room.
          <br /> <b>Housekeeping</b> is something guest can ask for the room,
          like cleaning, replacing towels, toiletries etc.
        </Tooltip>
      );
    } else if (isAccommodation) {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
          style={{ textAlign: 'left', fontSize: '12px' }}
        >
          <b>Information Only </b> to display text description with an image.<br />

          <b>Information & Action</b> to display text description, image and a button to take action.<br />

          <b>Open Rooms</b> to open Room Types list.<br />

          <b>Open Products</b> to open Products & Services.<br />

          <b>Open Chatbot</b> to open the AI Chatbot.<br />
          <b>Action Only</b> to take the action on click of the web widget menu.
          {/* <b>Service or Activity</b> are additional things you promote and sell,
          e.g. Golf, Spa, Ski and others.
          <br />
          <b>Amenity</b> are included things e.g. a Swimming pool.
          <br />
          <b>Aiva voucher</b> are vouchers you promote with{' '}
          <a
            href="www.getaiva.com"
            className="btn-link"
            style={{ textDecoration: 'underline', fontWeight: 'bold' }}
          >
            {' '}
            aiva{' '}
          </a>
          <br />
          <b>Retail</b> are shops in your premises.
          <br />
          <b>Product</b> are physical products you promote and sell */}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          placement="right"
          isOpen={typeToolTip}
          target="typetip"
          toggle={toggleTypeToolTip}
        >
          <b>Service</b> is one service like haircut, hair color and head
          message.
          <br /> <b>Package</b> is service bundle offering multiple services for
          sale as one combined service package.
          <br /> Special <b>Offer</b> is certain special value you can offer to
          your client.
        </Tooltip>
      );
    }
  };

  const titlePlaceholderText = () => {
    if (isDoctor) {
      return ("e.g. Shuttle Service");
    } else if (qbot) {
      return ("e.g. Shuttle Service");
    } else if (isAccommodation) {
      return ("e.g. Shuttle Service");
    } else {
      return ("$179 for Hair cut & colouring");
    }
  };

  const priceChangeTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and
          depends on the specific needs.
        </Tooltip>
      );
    } else if (qbot) {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and depend
          upon different conditions like{' '}
          {isServiceOrder
            ? 'day of the week and time spent.'
            : 'hair length, thickness etc.'}
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          placement="right"
          isOpen={priceToolTip}
          target="pricetip"
          toggle={togglePriceToolTip}
        >
          You can chose your digital assistant to give customer a single price
          or a range. Usually range is useful if price is not certain and depend
          upon different conditions like{' '}
          {isAccommodation
            ? 'day of the week and time spent.'
            : 'hair length, thickness etc.'}
        </Tooltip>
      );
    }
  };

  useEffect(() => {
    // Pre-selected lifecycle values
    const defaultCheckedValues = [
      'Pre Booking',
      'Pre Check-in',
      'At Property',
      'After Check-out',
    ];

    const updatedLifeCycle = guestLifeCycleList.map((item) => ({
      ...item,
      checked: defaultCheckedValues.includes(item.value),
    }));

    setLifeCycle(updatedLifeCycle);

    setMessengerData((prevData) => ({
      ...prevData,
      guestLifeCycle: updatedLifeCycle
        .filter((item) => item.checked)
        .map((item) => item.value),
    }));
  }, []);

  const categoryTooltipText = () => {
    if (isDoctor) {
      return (
        <Tooltip
          placement="right"
          isOpen={categoryToolTip}
          target="categoryToolTip"
          toggle={toggleCategoryToolTip}
        >
          Categories are sections under which all the included Web Widget Items shows in the AI Chatbot.

        </Tooltip>
      );
    }
  };

  const generatorCategorySelect = () => {
    if (isDoctor) {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={DoctorServicesCategoriesData}
        />
      );
    } else if (qbot) {
      if (isServiceOrder === true) {
        return (
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            isMulti={true}
            name="form-field-name"
            value={selectedOptions}
            onChange={handleChangeMulti}
            options={guestServiceCategory}
          />
        );
      } else {
        return (
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            isMulti={true}
            name="form-field-name"
            value={selectedOptions}
            onChange={handleChangeMulti}
            options={GuestServicesCategoriesData}
          />
        );
      }
    } else if (isAccommodation) {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={addonCategoryData}
        />
        // <Select
        //   components={{ Input: CustomSelectInput }}
        //   className="react-select"
        //   classNamePrefix="react-select"
        //   isMulti={true}
        //   name="form-field-name"
        //   value={selectedOptions}
        //   onChange={handleChangeMulti}
        //   options={AccommodationCategoriesData}
        // />
      );
    } else {
      return (
        <Select
          components={{ Input: CustomSelectInput }}
          className="react-select"
          classNamePrefix="react-select"
          isMulti={true}
          name="form-field-name"
          value={selectedOptions}
          onChange={handleChangeMulti}
          options={salonCategoriesData}
        />
      );
    }
  };

  if (Array.isArray(domains) && qbot === false && isServiceOrder !== true) {
    // console.log("domains", domains);
    domains.forEach((r) => {
      if (r.type === 'QuarantineBot') {
        setQbot(true);
      }
    });
  }

  if (Array.isArray(domains) && isDoctor === false && isServiceOrder !== true) {
    // console.log("domains", domains);
    domains.forEach((r) => {
      if (r.type === 'Doctors') {
        setIsDoctor(true);
      }
    });
  }

  if (Array.isArray(domains) && isAccommodation === false && isServiceOrder !== true) {
    //console.log("domains", domains);
    domains.forEach((r) => {
      if (r.type === 'AccommodationProviders' || r.type === 'AccommodationProvidersGroup' ||
        r.type === 'HolidayHomes' || r.type === 'HolidaysPark' ||
        r.type === 'UtilityProviders' || r.type === 'Activities' || r.type === 'Restaurant' ||
        propertyId === "-1") {
        setIsAccommodation(true);
        setIsBusinessOperator(false);
      }
      else if (r.type === "BusinessOperator") {
        setIsAccommodation(true);
        setIsBusinessOperator(true);
      }
    });
  }

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const toggleSvgGallery = () => {
    setSvgGalleryVisible(!svgGalleryVisible);
  };
  const selectedIcon = (image) => {
    setMessengerData({
      ...messengerData,
      iconLink: image.src,
    });
  };
  const selectedImage = (image) => {
    setMessengerData({
      ...messengerData,
      imageLink: image.src,
    });
  };

  const handleRemoveImage = () => {
    setMessengerData({
      ...messengerData,
      imageLink: '',
    });
  };

  const handleRemoveIcon = () => {
    setMessengerData({
      ...messengerData,
      iconLink: '',
    });
  };

  const [messengerData, setMessengerData] = useState({
    groupId: getGroupID(),
    propertyId: propertyId === "-1" ? null : propertyId,
    type: 'Package',
    title: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    displayText: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    conditions: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    status: 'Active',
    currency: 'NZD',
    priceRangeStart: 0,
    priceRangeEnd: 0,
    taxIncluded: true,
    categories: [],
    displayOrder: 1,
    creator: 'dashboard',
    imageData: '',
    imageLink: '',
    luisIntent: '',
    luisEntityKey: '',
    luisEntityValue: '',
    discount: 0,
    discountedPrice: 0,
    discountedPriceEnd: 0,
    taxPercentage: 0,
    taxAmount: 0,
    bookingMethod: 0,
    offerDiscount: false,
    promoCode: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    instructions: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    externalUrl: [
      {
        statement: '',
        languageCode: languageCode,
      },
    ],
    voucherId: '',
    voucherName: '',
    guestLifeCycle: [],
    suitability: [],
    messengerType: 'AddOnUpsells',
    membershipGroup: [],
    isGlobal: false,
    highlightItem: false,
    formId: '',
    formName: '',
    submitButtonText: [],
    categoryLayout: [],
    appearance: null,
    iconLink: '',
    categoryId: [{
      id: '',
      languageCode: languageCode,
    }],
    conversationFlowId: "",
    conversationFlowName: "",
    forms: [],
    embedIframe: "",
    embedIframeTop: "",
    categoriesType: [],
  });

  useEffect(() => {
    let guestCategoryList = [...GuestServicesCategoriesData];
    if (isServiceOrder === true) {
      setQbot(true);
      setIsDoctor(false);
      setIsAccommodation(false);
      setGuestServiceCategory(guestCategoryList);
    }
    if (propertyId != undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Vouchers_List}?groupId=${getGroupID()}&propertyId=${propertyId}&languageCode=${languageCode}&search=&status=All&pageNumber=${1}&pageSize=${100}&email=${res.data.email
            }`,
        }).then((res) => {
          if (res.data.vouchers !== undefined && res.data.vouchers !== null && res.data.vouchers.length > 0) {
            var voucherData = res.data.vouchers.filter(
              (item) => item.status !== 'Draft'
            );
            setVouchers(voucherData);
          }
        });
      });
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setIsAivaProperty(res.data.isAiva);
        })
        .catch((err) => console.error(err));
      AxiosAPI({
        method: 'get',
        url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=en`,
      })
        .then((res) => {
          setFormsData(res.data);
        })
        .catch((err) => console.error(err));
    }
    AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${languageCode}`,
    })
      .then(res => {
        setConversationFlowList(res.data.sets.filter(x => x.type === "ConversationFlow"));
      })
      .catch(err => {
        console.log(err);
      });
    const categoryOptions = addonCategoryData;
    if (isAccommodation === true) {
      if (allAddonCategoryData !== undefined && allAddonCategoryData.length > 0) {
        allAddonCategoryData.map((m, i) =>
          categoryOptions.push({
            label: m.title,
            value: m.id,
            key: i
          }))
      }
      setAddonCategoryData(categoryOptions);
    }
    const membershipOptions = membershipGroupData;
    if (allMembershipGroupData !== undefined && allMembershipGroupData.length > 0) {
      allMembershipGroupData.map((m, i) =>
        membershipOptions.push({
          label: m,
          value: m,
          key: i
        }))
    }
    setMembershipGroupData(membershipOptions);
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Messenger_By_Id}/${id}?groupId=${getGroupID()}&propertyId=${propertyId}`,
      })
        .then((res) => {
          if (isAccommodation === true) {
            let discountedPrice = 0;
            let discountedPriceEnd = 0;
            let body = {};
            body = Calculation(
              res.data.priceRangeStart,
              res.data.priceRangeEnd,
              res.data.taxIncluded,
              res.data.taxPercentage,
              res.data.discount,
              res.data.offerDiscount
            );
            if (body) {
              discountedPrice =
                body.discountedPrice === NaN ? 0 : body.discountedPrice;
              discountedPriceEnd =
                body.discountedPriceEnd === NaN ? 0 : body.discountedPriceEnd;
            }
            if (res.data.embedIframe && res.data.embedIframe !== null && res.data.embedIframe !== "") {
              setIsIframe(true);
            }
            if (res.data.embedIframeTop && res.data.embedIframeTop !== null && res.data.embedIframeTop !== "") {
              setIsIframeTop(true);
            }
            setMessengerData({
              ...res.data,
              discountedPrice: discountedPrice,
              discountedPriceEnd: discountedPriceEnd,
            });
          } else {
            setMessengerData(res.data);
          }
          var selectedcategories = [];
          try {
            if (isAccommodation === true) {
              res.data.categoryId.filter(k => k.languageCode === languageCode).map((item, i) => {
                if (item.id !== "") {
                  selectedcategories.push(
                    categoryOptions.filter((cat) => cat.value === item.id)[0]
                  )
                }
              });
              // res.data.categoryLayout.map((item, i) => {
              //   selectedcategories.push(
              //     categoryOptions.filter((cat) => cat.value === item.title)[0]
              //   )
              // });
            } else {
              res.data.categoryLayout.map((item) =>
                selectedcategories.push(
                  categoriesData.filter((cat) => cat.value === item.title)[0]
                )
              );
            }
          } finally {
          }
          setselectedOptions(selectedcategories);
          setselectedcategories(selectedcategories);
          var selectedGuestLifeCycle = [];
          try {
            if (
              res.data.guestLifeCycle !== null &&
              res.data.guestLifeCycle.length > 0
            ) {
              selectedGuestLifeCycle = lifeCycle.map((elem) => {
                var exist = res.data.guestLifeCycle.filter(
                  (item) => item === elem.value
                );
                if (exist.length > 0) {
                  elem.checked = true;
                } else {
                  elem.checked = false;
                }
                return {
                  ...elem,
                };
              });
              setLifeCycle(selectedGuestLifeCycle);
            } else {
              selectedGuestLifeCycle = lifeCycle.map((elem) => {
                if (elem.checked) {
                  elem.checked = false;
                }
                return { ...elem };
              });
              setLifeCycle(selectedGuestLifeCycle);
            }
          } finally {
          }
          const membershipGroup = selectedGuestLifeCycle.filter(i => i.checked === true && i.value === "Member Specific");
          setIsMembershipGroup(membershipGroup.length > 0 ? true : false);
          var selectedMemmbershipgroup = [];
          if (res.data.membershipGroup != null && res.data.membershipGroup.length > 0) {
            res.data.membershipGroup.map((item, i) => {
              selectedMemmbershipgroup.push(membershipOptions.filter((cat) => cat.value === item)[0]);
            });
          }
          setSelectedMembershipGroup(selectedMemmbershipgroup);
          var selectedSuitability = [];
          try {
            if (res.data.suitability !== null) {
              res.data.suitability.map((item) =>
                selectedSuitability.push(
                  suitabilityData.filter((cat) => cat.value === item)[0]
                )
              );
            }
          } finally {
          }
          setSelectedSuitability(selectedSuitability);
          var selectedCategoryType = [];
          try {
            if (res.data.categoriesType !== null) {
              res.data.categoriesType.map((item) =>
                selectedCategoryType.push(
                  productCategory.filter((cat) => cat.value === item)[0]
                )
              );
            }
          } finally {
          }
          setSelecetdTypeCategory(selectedCategoryType);
        })
        .catch((err) => console.log('err', err));
    } else {
      var cycle = guestLifeCycleList.map((item) => {
        if (item.checked === true) {
          item.checked = false;
        }
        return { ...item };
      });
      setLifeCycle(cycle);
    }
  }, [id]);

  const handleChangeMulti = (selectedOptions) => {
    if (selectedOptions.filter((i) => i.value === 'Add own tag').length === 0) {
      setselectedOptions(selectedOptions);
      var getExistingCat = messengerData.categoryId.filter(k => k.languageCode !== languageCode);
      const categoriesArr = [...getExistingCat];
      allAddonCategoryData.map((i) => selectedOptions.map((elem) => {
        if (elem.value === i.id) {
          return categoriesArr.push({ id: i.id, languageCode: languageCode });
        }
      }));
      setMessengerData({
        ...messengerData,
        //categoryLayout: categoriesArr,
        categoryId: categoriesArr
      });
    } else {
      setAddCategoryTagModel(true);
    }
  };

  const handleChangeMultiMembershipGroup = (selectedMembershipGroup) => {
    if (selectedMembershipGroup.filter((i) => i.value === 'Add own tag').length === 0) {
      setSelectedMembershipGroup(selectedMembershipGroup);
      const membershipGroupArr = selectedMembershipGroup.map((elem) => elem.value);
      setMessengerData({
        ...messengerData,
        membershipGroup: membershipGroupArr,
      });
    } else {
      setAddTagModel(true);
      setIsCategoryTag(false);
    }
  };
  const handleChangeMultiSuitability = (selectedSuitability) => {
    setSelectedSuitability(selectedSuitability);
    const suitabilityArr = selectedSuitability.map((elem) => elem.value);
    setMessengerData({
      ...messengerData,
      suitability: suitabilityArr,
    });
  };
  const handleChangeCategoryType = (selectedTypeCategory) => {
    setSelecetdTypeCategory(selectedTypeCategory);
    const categoryArr = selectedTypeCategory.map((elem) => elem.value);
    setMessengerData({
      ...messengerData,
      categoriesType: categoryArr,
    });
  };
  const handleLifeCycleChange = (e) => {
    const values = lifeCycle.map((elem) => {
      if (elem.value === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setLifeCycle(values);
    const lifecycleArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.value);
    setIsMembershipGroup(lifecycleArr.includes("Member Specific"));
    setMessengerData({
      ...messengerData,
      guestLifeCycle: lifecycleArr,
    });
  };
  const handleChangeVoucher = (e) => {
    var voucher = vouchers
      .filter((item) => item.id === e.target.value)
      .map((i) => i.name);
    let voucherName = '';
    if (voucher.length > 0) {
      voucherName = voucher[0];
    }
    setMessengerData({
      ...messengerData,
      voucherId: e.target.value,
      voucherName: voucherName,
    });
  };
  const getFormName = (statement) => {
    if (statement !== undefined && statement.length > 0) {
      const index = statement.findIndex((m) => m.languageCode === languageCode);
      if (index === -1) {
        const englishIndex = statement.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statement[englishIndex].id;
        }
      } else {
        return statement[index].id;
      }
    } else {
      return '';
    }
  };
  const handleChangeForm = (e) => {
    const selectedFormId = e.target.value;
    const FIXED_LANG = "en";
    const selectedForm = formsData.find(f => f.id === selectedFormId);
    const selectedFormName = selectedForm ? selectedForm.name : "";

    if (messengerData.forms.length > 0) {
      const index = messengerData.forms.findIndex(
        (m) => m.languageCode === FIXED_LANG
      );

      if (index === -1) {
        setMessengerData({
          ...messengerData,
          forms: [
            { id: selectedFormId, languageCode: FIXED_LANG }
          ],
          formId: selectedFormId,
          formName: selectedFormName,
        });
      } else {
        const newArr = [...messengerData.forms];
        newArr[index] = {
          ...newArr[index],
          id: selectedFormId,
        };

        setMessengerData({
          ...messengerData,
          forms: newArr,
          formId: selectedFormId,
          formName: selectedFormName,
        });
      }
    } else {
      setMessengerData({
        ...messengerData,
        forms: [
          { id: selectedFormId, languageCode: FIXED_LANG }
        ],
        formId: selectedFormId,
        formName: selectedFormName,
      });
    }
  };


  const handleChangeConFlow = (e) => {
    let conFlowId = e.target.value;
    let conFlowName = '';
    var con = conversationFlowList.filter((item) => item.id === e.target.value);
    if (con.length > 0) {
      conFlowName = con[0].name;
    }
    setMessengerData({
      ...messengerData,
      conversationFlowId: conFlowId,
      conversationFlowName: conFlowName,
    });
  };
  const handleChange = (e) => {
    let taxAmount = messengerData.taxAmount === 0 ? 0 : messengerData.taxAmount;
    let discountedPrice =
      messengerData.discountedPrice === 0 ? 0 : messengerData.discountedPrice;
    let discountedPriceEnd =
      messengerData.discountedPriceEnd === 0 ? 0 : messengerData.discountedPriceEnd;
    if (isAccommodation === true || isServiceOrder === true) {
      let body = {};
      if (e.target.name === 'priceRangeStart') {
        body = Calculation(
          e.target.value === "" ? 0 : e.target.value,
          messengerData.priceRangeEnd !== 0 ? messengerData.priceRangeEnd : 0,
          messengerData.taxIncluded !== 0 ? messengerData.taxIncluded : 0,
          messengerData.taxPercentage !== 0 ? messengerData.taxPercentage : 0,
          messengerData.discount !== 0 ? messengerData.discount : 0,
          messengerData.offerDiscount
        );
      }
      if (e.target.name === 'priceRangeEnd') {
        body = Calculation(
          messengerData.priceRangeStart !== 0 ? messengerData.priceRangeStart : 0,
          e.target.value === "" ? 0 : e.target.value,
          messengerData.taxIncluded !== 0 ? messengerData.taxIncluded : 0,
          messengerData.taxPercentage !== 0 ? messengerData.taxPercentage : 0,
          messengerData.discount !== 0 ? messengerData.discount : 0,
          messengerData.offerDiscount
        );
      }
      if (e.target.name === 'taxIncluded') {
        body = Calculation(
          messengerData.priceRangeStart !== 0 ? messengerData.priceRangeStart : 0,
          messengerData.priceRangeEnd !== 0 ? messengerData.priceRangeEnd : 0,
          e.target.value,
          messengerData.taxPercentage !== 0 ? messengerData.taxPercentage : 0,
          messengerData.discount !== 0 ? messengerData.discount : 0,
          messengerData.offerDiscount
        );
      }
      if (e.target.name === 'taxPercentage') {
        body = Calculation(
          messengerData.priceRangeStart !== 0 ? messengerData.priceRangeStart : 0,
          messengerData.priceRangeEnd !== 0 ? messengerData.priceRangeEnd : 0,
          messengerData.taxIncluded !== 0 ? messengerData.taxIncluded : 0,
          e.target.value,
          messengerData.discount !== 0 ? messengerData.discount : 0,
          messengerData.offerDiscount
        );
      }
      if (e.target.name === 'discount') {
        body = Calculation(
          messengerData.priceRangeStart !== 0 ? messengerData.priceRangeStart : 0,
          messengerData.priceRangeEnd !== 0 ? messengerData.priceRangeEnd : 0,
          messengerData.taxIncluded !== 0 ? messengerData.taxIncluded : 0,
          messengerData.taxPercentage !== 0 ? messengerData.taxPercentage : 0,
          e.target.value === "" ? 0 : e.target.value,
          messengerData.offerDiscount
        );
      }
      if (
        e.target.name === 'priceRangeStart' ||
        e.target.name === 'priceRangeEnd' ||
        e.target.name === 'taxIncluded' ||
        e.target.name === 'taxPercentage' ||
        e.target.name === 'discount'
      ) {
        if (body) {
          taxAmount = body.taxAmount === NaN ? 0 : body.taxAmount;
          discountedPrice =
            body.discountedPrice === NaN ? 0 : body.discountedPrice;
          discountedPriceEnd =
            body.discountedPriceEnd === NaN ? 0 : body.discountedPriceEnd;
        }
      }
    }
    // else if (isServiceOrder === true) {
    //   if (e.target.name === "priceRangeStart") {
    //     discountedPrice = parseFloat(e.target.value);

    //   }
    //   if (e.target.name === "taxIncluded") {
    //     let mainPrice = parseFloat(messengerData.priceRangeStart);
    //     if (e.target.value === true) {
    //       let amount = ((parseFloat(messengerData.taxPercentage) + 100) / 100).toFixed(2);
    //       let tax = parseFloat(mainPrice / amount).toFixed(2);
    //       taxAmount = parseFloat(mainPrice - tax).toFixed(2);
    //     }
    //   }
    // }
    if (e.target.name === 'bookingMethod') {
      if (e.target.value === 'aiva') {
        messengerData.externalUrl = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
        messengerData.promoCode = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
        messengerData.instructions = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
      } else if (e.target.value === 'ExternalURL') {
        messengerData.promoCode = [
          {
            statement: '',
            languageCode: languageCode,
          },
        ];
      }
    }
    // console.log(messengerData);
    setMessengerData({
      ...messengerData,
      taxAmount: taxAmount,
      discountedPrice: discountedPrice,
      discountedPriceEnd: discountedPriceEnd,
      [e.target.name]: e.target.name === "discount" || e.target.name === "priceRangeEnd" || e.target.name === "priceRangeStart" ?
        e.target.value === "" ? 0 : e.target.value :
        e.target.value,
    });
  };
  const Calculation = (
    startPrice,
    endPrice,
    taxIncluded,
    taxPercentage,
    discount,
    offerDiscount
  ) => {
    let mainPrice = 0;
    let discountPrice = parseFloat(startPrice);
    let discountPrice2 = parseFloat(endPrice);
    let taxxAmount = 0;
    discount = discount === NaN ? 0 : discount;
    mainPrice = (parseFloat(startPrice) + parseFloat(endPrice)) / 2;
    let price =
      parseFloat(mainPrice) + parseFloat(taxIncluded === 'true' ? 0 : 0);
    if (offerDiscount && parseFloat(discount) !== 0) {
      let price1 = parseFloat(startPrice);
      let price2 = parseFloat(endPrice);
      let discountAmt = Math.round((price1 * parseFloat(discount)) / 100);
      discountPrice = Math.round(price1 - discountAmt);
      let discountAmt2 = Math.round((price2 * parseFloat(discount)) / 100);
      discountPrice2 = Math.round(price2 - discountAmt2);
    }
    if (taxIncluded === true) {
      let amount = ((parseFloat(taxPercentage) + 100) / 100).toFixed(2);
      let tax = parseFloat(mainPrice / amount).toFixed(2);
      taxxAmount = parseFloat(mainPrice - tax).toFixed(2);
    } else {
      taxxAmount = (
        (parseFloat(mainPrice) * parseFloat(taxPercentage)) /
        100
      ).toFixed(2);
    }
    let amo = {
      taxAmount: taxxAmount,
      discountedPrice: discountPrice,
      discountedPriceEnd: discountPrice2,
    };
    return amo;
  };
  // const getFiles = (files) => {
  //     setMessengerData({
  //         ...messengerData,
  //         imageData: files.base64.split(",")[1],
  //     });
  // }
  const handleCheckedDiscount = (e) => {
    let discount = e.target.checked ? messengerData.discount : 0;
    let discountedPrice = e.target.checked
      ? messengerData.discount === 0
        ? messengerData.priceRangeStart
        : messengerData.discountedPrice
      : messengerData.priceRangeStart;
    let discountedPriceEnd = e.target.checked
      ? messengerData.discount === 0
        ? messengerData.priceRangeEnd
        : messengerData.discountedPriceEnd
      : messengerData.priceRangeEnd;
    if (isAccommodation === true || isServiceOrder === true) {
      let body = {};
      body = Calculation(
        messengerData.priceRangeStart,
        messengerData.priceRangeEnd,
        messengerData.taxIncluded,
        messengerData.taxPercentage,
        messengerData.discount,
        e.target.checked
      );
    }
    setMessengerData({
      ...messengerData,
      discount: discount,
      discountedPrice: discountedPrice,
      discountedPriceEnd: discountedPriceEnd,
      offerDiscount: e.target.checked,
    });
  };
  const handleCheckedGlobal = (e) => {
    if (e.target.checked === true) {
      if (messengerData.formId !== "" && messengerData.formId !== "0") {
        var checkform = formsData.filter(i => i.id === messengerData.formId);
        if (checkform.length > 0) {
          var isformGlobal = checkform[0].isGlobal;
          if (isformGlobal === true) {
            setMessengerData({
              ...messengerData,
              isGlobal: e.target.checked
            })
          }
          else {
            setErrorModel({
              isVisible: true,
              msg: "This Messenger item has a Form linked to it. Mark the Form as global before proceeding with the Messenger item."
            });
          }
        }
      }
      else {
        setMessengerData({
          ...messengerData,
          isGlobal: e.target.checked
        })
      }
    }
    else {
      setMessengerData({
        ...messengerData,
        isGlobal: e.target.checked
      })
    }
  }
  const handleCheckedHighlightItem = (e) => {
    setMessengerData({
      ...messengerData,
      highlightItem: e.target.checked
    })
  }

  const handleChangeArr = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setMessengerData({
      ...messengerData,
      [key]: [
        {
          statement: value,
          languageCode: languageCode,
        },
      ],
    });
  };
  const toggleTitleToolTip = () => {
    settitleToolTip(!titleToolTip);
  };
  const toggleTypeToolTip = () => {
    setTypeToolTip(!typeToolTip);
  };
  const togglePriceToolTip = () => {
    setpriceToolTip(!priceToolTip);
  };
  const toggleCategoryToolTip = () => {
    setCategoryToolTip(!categoryToolTip);
  };
  const toggleGlobelToolTip = () => {
    setGlobelToolTip(!globelToolTip);
  };

  const handleDelete = () => {
    var selectedresponsecodes = [];
    if (!isDoctor && !isAccommodation) {
      try {
        messengerData.categories.map((item) => {
          let categoryMapp = categoryBotResponseCodeMapping.filter(
            (code) => code.category === item
          );
          if (categoryMapp.length > 0) {
            selectedresponsecodes.push(categoryMapp[0].responseCode);
          }
        });
      } finally {
      }
    }
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Messenger}/${id}`,
      data: {
        propertyId: propertyId === "-1" ? null : propertyId,
        deleter: 'dashboard',
        botResponseCode: selectedresponsecodes,
      },
    })
      .then((res) => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This messenger will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const IconGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={svgGalleryVisible}
                toggle={toggleSvgGallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleSvgGallery}>
                  Select Svg Icon or Upload New Svg
                </ModalHeader>
                <ModalBody>
                  <IconGallery
                    propertyId={propertyId}
                    selectedSvg={selectedIcon}
                    togglegallery={toggleSvgGallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleSubmit = () => {
    var isValid = false;
    if (messengerData.bookingMethod === "SubmitForm") {
      const index = messengerData.forms.filter((m) => m.languageCode === 'en');
      if (index.length > 0 && index[0].id !== "") {
        isValid = true;
      }
    } else {
      isValid = true
    }

    if (isValid) {
      var selectedresponsecodes = [];
      var selectedLuis = [];

      // if (!isDoctor && !isAccommodation) {
      //   try {
      //     messengerData.categories.map((item) => {
      //       let categoryMapp = categoryBotResponseCodeMapping.filter(
      //         (code) => code.category === item
      //       );
      //       if (categoryMapp.length > 0) {
      //         selectedresponsecodes.push(categoryMapp[0].responseCode);
      //       }
      //     });
      //   } finally {
      //   }
      // }
      // if (isDoctor) {
      //   console.log('selectedcategories', messengerData.categories);
      //   try {
      //     messengerData.categories.map((item) =>
      //       selectedLuis.push({
      //         luisIntent: drBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].intent,
      //         luisEntityKey: drBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].entity_key,
      //         luisEntityValue: drBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].entity_value,
      //       })
      //     );
      //   } finally {
      //   }
      // }
      // if (isAccommodation) {
      //   //console.log('selectedcategories', messengerData.categories);
      //   try {
      //     messengerData.categories.map((item) =>
      //       selectedLuis.push({
      //         luisIntent: accoBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].intent,
      //         luisEntityKey: accoBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].entity_key,
      //         luisEntityValue: accoBotResponseCodeMapping.filter(
      //           (code) => code.category === item
      //         )[0].entity_value,
      //       })
      //     );
      //   } finally {
      //   }
      // }
      console.log(selectedLuis);
      if (id !== undefined) {
        var deletedcategories = [];
        var deletedresponsecodes = [];
        // if (!isDoctor && !isAccommodation) {
        //   try {
        //     selectedcategories.map((item) =>
        //       messengerData.categories.filter((code) => code === item.value)
        //         .length === 0
        //         ? deletedcategories.push(item.value)
        //         : null
        //     );
        //   } finally {
        //   }
        //   try {
        //     deletedcategories.map((item) => {
        //       let categoryMapp = categoryBotResponseCodeMapping.filter(
        //         (code) => code.category === item
        //       );
        //       if (categoryMapp.length > 0) {
        //         deletedresponsecodes.push(categoryMapp[0].responseCode);
        //       }
        //     });
        //   } finally {
        //   }
        // }
        const formmatedData = {
          ...messengerData,
          CurrentGroupId: getGroupID(),
          CurrentPropertyId: propertyId === "-1" ? null : propertyId,
          Updater: 'admin',
          botResponseCode: selectedresponsecodes,
          deleteBotResponseCode: deletedresponsecodes,
          categoryLuisSettings: selectedLuis,
        };

        console.log(23, formmatedData);

        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Messenger}/${id}`,
          data: formmatedData,
        })
          .then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
              && res.data.Messages !== null && res.data.Messages.length > 0) {
              setMsg(res.data.Messages);
              setOpen(true);
            } else {
              toggleModal();
              setMessengerData({});
              //console.log(res.data);
              setTimeout(() => {
                LoadData(languageCode);
              }, 1000);
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        const formmatedData = {
          ...messengerData,
          botResponseCode: selectedresponsecodes,
          categoryLuisSettings: selectedLuis,
        };
        console.log(24, formmatedData)
        AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_Messenger}`,
          data: formmatedData,
        })
          .then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
              && res.data.Messages !== null && res.data.Messages.length > 0) {
              setMsg(res.data.Messages);
              setOpen(true);
            } else {
              toggleModal();
              setTimeout(() => {
                LoadData(languageCode);
              }, 1000);
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    }
    else {
      setErrorModel({
        isVisible: true,
        msg: "You didn't select form! please select a form."
      });
    }
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === languageCode);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeHighlightsArr = (source, e) => {
    if (source === 'user') {
      if (messengerData.displayText.length > 0) {
        const index = messengerData.displayText.findIndex(
          (m) => m.languageCode === languageCode
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: languageCode,
          };
          setMessengerData({
            ...messengerData,
            displayText: [...messengerData.displayText, newStatement],
          });
        } else {
          let newArr = [...messengerData.displayText];
          newArr[index].statement = e;
          setMessengerData({
            ...messengerData,
            displayText: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: languageCode,
        };
        setMessengerData({
          ...messengerData,
          displayText: [...messengerData.displayText, newStatement],
        });
      }
    }
  };
  const handleChangeConditionsArr = (source, e) => {
    if (source === 'user') {
      if (messengerData.conditions.length > 0) {
        const index = messengerData.conditions.findIndex(
          (m) => m.languageCode === languageCode
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: languageCode,
          };
          setMessengerData({
            ...messengerData,
            conditions: [...messengerData.conditions, newStatement],
          });
        } else {
          let newArr = [...messengerData.conditions];
          newArr[index].statement = e;
          setMessengerData({
            ...messengerData,
            conditions: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: languageCode,
        };
        setMessengerData({
          ...messengerData,
          conditions: [...messengerData.conditions, newStatement],
        });
      }
    }
  };
  const handleChangeTitle = (e) => {
    if (messengerData.title.length > 0) {
      const index = messengerData.title.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: languageCode,
        };
        setMessengerData({
          ...messengerData,
          title: [...messengerData.title, newStatement],
        });
      } else {
        let newArr = [...messengerData.title];
        newArr[index].statement = e.target.value;
        setMessengerData({
          ...messengerData,
          title: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: languageCode,
      };
      setMessengerData({
        ...messengerData,
        title: [...messengerData.title, newStatement],
      });
    }
  }
  const handleChangeSubmitButtonText = (e) => {
    if (messengerData.submitButtonText.length > 0) {
      const index = messengerData.submitButtonText.findIndex(
        (m) => m.languageCode === languageCode
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: languageCode,
        };
        setMessengerData({
          ...messengerData,
          submitButtonText: [...messengerData.submitButtonText, newStatement],
        });
      } else {
        let newArr = [...messengerData.submitButtonText];
        newArr[index].statement = e.target.value;
        setMessengerData({
          ...messengerData,
          submitButtonText: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: languageCode,
      };
      setMessengerData({
        ...messengerData,
        submitButtonText: [...messengerData.submitButtonText, newStatement],
      });
    }
  }
  const handleSignUpAiva = () => {
    window.open('https://app.getaiva.com/user/vouchersignup');
  };
  const handleLearnMoreAiva = () => {
    window.open('https://getaiva.com/');
  };
  const handleOwnCategoryTag = (data) => {
    let keyValue = addonCategoryData.length;
    let tag = [...addonCategoryData];
    tag.push({ label: data.title, value: data.id, key: keyValue });
    let tag1 = [...selectedOptions];
    tag1.push({ label: data.title, value: data.id, key: keyValue });
    setselectedOptions(tag1);
    setAddonCategoryData(tag);
    setselectedcategories(tag1);
    const categoriesArr = [...messengerData.categoryId];
    categoriesArr.push({ id: data.id, languageCode: data.languageCode });
    setMessengerData({
      ...messengerData,
      // categoryLayout: [data],
      categoryId: categoriesArr
    });
  }
  const handleUpdateOwnCategoryTag = (data) => {
    var newAddonlist = addonCategoryData.filter(i => i.value !== data.id);
    let keyValue = newAddonlist.length;
    let tag = [...newAddonlist];
    tag.push({ label: data.title, value: data.id, key: keyValue });
    var newselectedoption = selectedOptions.filter(i => i.value !== data.id);
    let tag1 = [...newselectedoption];
    tag1.push({ label: data.title, value: data.id, key: keyValue });
    setselectedOptions(tag1);
    setAddonCategoryData(tag);
    setselectedcategories(tag1);
    var filterexisting = messengerData.categoryId.filter(i => i.id !== data.id);
    const categoriesArr = [...filterexisting];
    categoriesArr.push({ id: data.id, languageCode: data.languageCode });
    // allAddonCategoryData.map((i) =>  tag1.map((elem) =>{
    //   if (elem.value === i.id) {
    //     return categoriesArr.push(i.id);
    //   }
    // }));
    setMessengerData({
      ...messengerData,
      //categoryLayout: categoriesArr,
      categoryId: categoriesArr
    });
  }
  const handleCustomisationsTag = (val) => {
    if (isCategoryTag === true) {
      let keyValue = addonCategoryData.length;
      let tag = [...addonCategoryData];
      tag.push({ label: val, value: val, key: keyValue });
      let tag1 = [...selectedOptions];
      tag1.push({ label: val, value: val, key: keyValue });
      setselectedOptions(tag1);
      setAddonCategoryData(tag);
      setselectedcategories(tag1);
      setAddTagModel(!addTagModel);
      setOwnTag('');
      const tagsArr = tag1.map((elem) => elem.value);
      setMessengerData({
        ...messengerData,
        categories: tagsArr,
      });
    }
    else {
      let keyValue = membershipGroupData.length;
      let tag = [...membershipGroupData];
      tag.push({ label: val, value: val, key: keyValue });
      let tag1 = [...selectedMembershipGroup];
      tag1.push({ label: val, value: val, key: keyValue });
      setSelectedMembershipGroup(tag1);
      setMembershipGroupData(tag);
      setAddTagModel(!addTagModel);
      setOwnTag('');
      const tagsArr = tag1.map((elem) => elem.value);
      setMessengerData({
        ...messengerData,
        membershipGroup: tagsArr,
      });
    }
  };
  const handleEditCategory = () => {
    setIsEditCategory(true);
    setAddCategoryTagModel(true);
  }
  const handleAppearance = (data) => {
    setMessengerData({ ...messengerData, appearance: data });
  }
  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>
          {formLabel}{' '}
          {isServiceOrder === true ? (
            <IntlMessages id="menu.guestservice"></IntlMessages>
          ) : (
            <IntlMessages id="virtual-messenger" />
          )}
        </ModalHeader>
        {messengerData != undefined && (
          <ModalBody>
            {/* <pre>{JSON.stringify(messengerData, null, 2)}</pre> */}
            <Label className="mt-3">
              Title <i className="demo-icon simple-icon-info" id="titletip"></i>
            </Label>

            <Tooltip
              placement="right"
              isOpen={titleToolTip}
              target="titletip"
              toggle={toggleTitleToolTip}
            >
              Title of the Web Widget Menu that appers as the main display.
            </Tooltip>
            <Input
              type="text"
              onChange={handleChangeTitle}
              value={getLocalStatement(messengerData.title)}
              name="title"
              maxLength={50}
              placeholder={titlePlaceholderText()}
            />
            <Label className="mt-3 d-flex">
              Type
              <div className='ml-1' >
                <i className="demo-icon simple-icon-info" id="typetip"></i>
                {/*}  <svg viewBox="0 0 77.78 122.88"><g>
                  <path d="M3.05,87.53L0.16,98.06c-0.36,1.32,0.41,2.74,1.72,3.14l10.08,3.11l-10.08,3.11c-1.31,0.41-2.09,1.82-1.72,3.14l2.89,10.53 c0.36,1.32,1.73,2.08,3.04,1.67l32.83-10.13l32.83,10.13c1.31,0.41,2.68-0.35,3.04-1.67l2.89-10.53c0.36-1.32-0.41-2.74-1.72-3.14 l-10.08-3.11l10.08-3.11c1.31-0.41,2.09-1.82,1.72-3.14L74.8,87.53c-0.36-1.32-1.73-2.07-3.04-1.67L38.92,95.99L6.09,85.86 C4.78,85.45,3.41,86.21,3.05,87.53L3.05,87.53z M12.03,21.81c1.44,10.24,3.67,17.99,7.46,20.86c0.07-3.47,0.42-6.89,1.09-10.23 c2.19-10.94,5.71-11.53,9.09-19.62C31.33,8.85,31.79,4.61,30.78,0C42.91,2.1,54.17,20.38,57,43.63c3.02-3.94,4.83-8.5,5.17-13.78 c5.35,5.48,8,11.99,8.99,19.14c2,13.68-2.2,22.54-13.3,26.05c2.47-5.67,1.9-10.05-0.69-15.83c-1.1-2.45-2.52-4.59-4.33-6.37 c-0.79,5.62-2.02,9.87-4.09,11.45c-0.04-1.91-0.23-3.78-0.6-5.61c-1.2-6.01-3.13-6.33-4.99-10.77c-0.91-2.18-1.16-4.51-0.61-7.04 c-6.65,1.15-12.83,11.19-14.39,23.94c-1.66-2.16-2.65-4.66-2.84-7.56c-2.93,3-4.39,6.58-4.94,10.5c-0.55,3.77-0.25,6.87,0.97,9.27 c-8.53-0.98-14.26-5.73-17.88-13.41c-5.19-11-4.26-19.19,0.65-30.18C6.13,28.96,8.73,25.06,12.03,21.81L12.03,21.81z" /></g>
                </svg>*/}
              </div>
            </Label>
            {typeTooltipText()}
            <Input
              type="select"
              name="type"
              value={messengerData.type}
              onChange={handleChange}
            >
              <option value="0">Select</option>
              {qbot === false ? (
                <Fragment>
                  {isAccommodation === true ? (
                    <Fragment>
                      {isBusinessOperator === true ?
                        (<Fragment>
                          <option value="InformationOnly">Information Only</option>
                          <option value="ServiceActivity">Information & Action</option>
                          <option value="TitleAction">Action Only</option>
                          <option value="OpenProducts">Open Products</option>
                          <option value="OpenChatbot">Open Chatbot</option>
                        </Fragment>) :
                        (<Fragment>
                          <option value="InformationOnly">Information Only</option>
                          <option value="ServiceActivity">
                            Information & Action
                          </option>
                          <option value="TitleAction">Action Only</option>
                          {/* <option value="Amentity">Amentity</option>
                          <option value="aivaVoucher">aiva Voucher</option>
                          <option value="Retail">Retail</option>
                          <option value="Product">Product</option>
                          <option value="InformationOnly">Information Only</option>
                          <option value="RoomService">Room Service</option>
                          <option value="Housekeeping">Housekeeping</option>
                          <option value="OpenChatbot">Open Chatbot</option> */}
                          <option value="OpenRooms">Open Rooms</option>
                          <option value="OpenProducts">Open Products</option>
                          <option value="OpenChatbot">Open Chatbot</option>
                        </Fragment>)}

                    </Fragment>
                  ) : (
                    <Fragment>
                      <option value="Package">Package</option>
                      <option value="Offer">Offer</option>
                      <option value="Service">Service</option>
                    </Fragment>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <option value="RoomService">Room Service</option>
                  <option value="Housekeeping">Housekeeping</option>
                </Fragment>
              )}
            </Input>
            {messengerData.type === "OpenProducts" && (
              <Fragment>
                <Label className="mt-3">Product Categories</Label>
                <Select
                  components={{ Input: CustomSelectInput }}
                  className="react-select"
                  classNamePrefix="react-select"
                  isMulti={true}
                  name="form-field-name"
                  value={selectedTypeCategory}
                  onChange={handleChangeCategoryType}
                  options={productCategory}
                />
              </Fragment>
            )}
            {isAivaProperty === true && messengerData.type === 'aivaVoucher' ? (
              <Fragment>
                <Label className="mt-3">Select Voucher(s)</Label>
                <Input
                  type="select"
                  name="vouchers"
                  value={messengerData.voucherId}
                  onChange={handleChangeVoucher}
                >
                  <option value="">Select</option>
                  {vouchers.length > 0 &&
                    vouchers.map(
                      (item) =>
                        item.name !== '' && (
                          <option value={item.id}>{item.name}</option>
                        )
                    )}
                </Input>
              </Fragment>
            ) : (
              messengerData.type === 'aivaVoucher' && (
                <div className="text-center p-2 mt-2">
                  <p style={{ fontSize: '15px' }}>
                    <b>aiva</b> is an automated, direct sell voucher system
                    allowing you to offer fully branded vouchers on your
                    website.{' '}
                  </p>
                  <p className="mt-3" style={{ fontSize: '15px' }}>
                    Currently, you do not have an account for <b>aiva</b>. It's
                    quick, inexpensive, simple and smart. Ten minutes is all it
                    takes to sign-up and upload your first voucher.
                  </p>
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: 'column',
                      alignContent: 'center',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleLearnMoreAiva()}
                      size="xs"
                    >
                      Learn More <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                    <Button
                      style={{ marginTop: '20px' }}
                      color="primary"
                      onClick={() => handleSignUpAiva()}
                      size="xs"
                    >
                      Sign Up <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                  </div>
                </div>
              )
            )}
            {messengerData.voucherId !== null &&
              messengerData.voucherId !== '' &&
              messengerData.voucherName !== null &&
              messengerData.voucherName !== '' &&
              messengerData.type === 'aivaVoucher' && (
                <div className="text-left p-2 mt-2">
                  <span>
                    <a
                      href={
                        `${process.env.REACT_APP_VOUCHERAIVA_URL}/vhp?id=` +
                        messengerData.voucherId
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{ textDecoration: 'underline', fontWeight: '600' }}
                    >
                      Click here
                    </a>{' '}
                    to view the voucher
                  </span>
                  <br />
                </div>
              )}
            {messengerData.type !== 'aivaVoucher' && messengerData.type !== 'TitleAction' ? (
              <Fragment>
                <div className="row">
                  <div className="col-12">
                    {isIframeTop ?
                      <Fragment>
                        <Label className="mt-3">Embed Iframe</Label>
                        <Input
                          type="textarea"
                          onChange={handleChange}
                          value={messengerData.embedIframeTop}
                          name="embedIframeTop"
                          placeholder={"Enter Iframe"}
                        />
                      </Fragment> :
                      <Button color="primary" className="mt-3" size="xs" outline onClick={() => setIsIframeTop(true)}>
                        +Embed Iframe</Button>
                    }
                  </div>
                </div>
                <Label className="mt-3">Description</Label>
                <ReactQuill
                  theme="snow"
                  value={getLocalStatement(messengerData.displayText)}
                  onChange={(content, delta, source) =>
                    handleChangeHighlightsArr(source, content)
                  }
                  modules={quillModules}
                  formats={quillFormats}
                  name="displayText"
                />

                <div className="row">
                  <div className="col-12">
                    {isIframe ?
                      <Fragment>
                        <Label className="mt-3">Embed Iframe</Label>
                        <Input
                          type="textarea"
                          onChange={handleChange}
                          value={messengerData.embedIframe}
                          name="embedIframe"
                          placeholder={"Enter Iframe"}
                        />
                      </Fragment> :
                      <Button color="primary" className="mt-3" size="xs" outline onClick={() => setIsIframe(true)}>
                        +Embed Iframe</Button>
                    }
                  </div>
                </div>
              </Fragment>
            ) : null}
            <div className="row d-none" >
              <div className="col-12">
                <Label className="mt-3"></Label>
                <CustomInput
                  type="checkbox"
                  id="highlightItem"
                  label="Highlight This Item"
                  checked={messengerData.highlightItem}
                  onChange={handleCheckedHighlightItem}
                  disabled
                />
              </div>
            </div>
            {isAivaProperty === false && messengerData.type === 'aivaVoucher' ? (
              ''
            ) : (
              <Fragment>
                <div className='d-none'>
                  <Label className="mt-3">Guest Lifecycle Applicability</Label>
                  <div className="row mt-2">
                    {lifeCycle.map((item, index) => (
                      <div className="col-md-6" key={index}>
                        <CustomInput
                          type="checkbox"
                          id={'guestLifeCycle' + index}
                          value={item.value}
                          label={item.label}
                          checked={item.checked}
                          onChange={handleLifeCycleChange}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                {isMembershipGroup && (
                  <Fragment>
                    <Label className="mt-3">Membership Group</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedMembershipGroup}
                      onChange={handleChangeMultiMembershipGroup}
                      options={membershipGroupData}
                    />
                  </Fragment>
                )}
                <div className='d-none '>
                  <Label className="mt-3 ">Suitability</Label>
                  <Select
                    components={{ Input: CustomSelectInput }}
                    className="react-select"
                    classNamePrefix="react-select"
                    isMulti={true}
                    name="form-field-name"
                    value={selectedSuitability}
                    onChange={handleChangeMultiSuitability}
                    options={suitabilityData}
                  />
                </div>
                <Label className="mt-3">Status</Label>
                <Input
                  type="select"
                  name="status"
                  value={messengerData.status}
                  onChange={handleChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Draft">Draft</option>
                  <option value="Archieve">Archive</option>
                </Input>
                <Label className="mt-3">
                  Categories{' '}
                  {isDoctor && (
                    <i
                      className="demo-icon simple-icon-info"
                      id="categoryToolTip"
                    ></i>
                  )}
                </Label>
                {categoryTooltipText()}
                {generatorCategorySelect()}
                {id !== undefined &&
                  <div className='text-left mt-1'>
                    <Button color="primary" size="xs" outline onClick={() => handleEditCategory()}><FontAwesomeIcon icon={faEdit} />
                      {""}<IntlMessages id="survey.edit" /> <IntlMessages id="survey.category" /></Button>
                  </div>
                }
              </Fragment>
            )}

            {messengerData.type !== 'aivaVoucher' && (
              <Fragment>
                <div className='d-none'>
                  {qbot === false ? (
                    messengerData.type !== 'Retail' && messengerData.type !== 'InformationOnly' && messengerData.type !== "OpenProducts" && (
                      <Fragment >
                        <Label className={id !== undefined ? "" : "mt-3"}>
                          Price Range{' '}
                          <i
                            className="demo-icon simple-icon-info"
                            id="pricetip"
                          ></i>{' '}
                        </Label>
                        {priceChangeTooltipText()}
                      </Fragment>
                    )
                  ) : isServiceOrder === true ? (
                    <Fragment >
                      <Label className={id !== undefined ? "" : "mt-3"}>
                        Price Range{' '}
                        <i
                          className="demo-icon simple-icon-info"
                          id="pricetip"
                        ></i>{' '}
                      </Label>
                      {priceChangeTooltipText()}
                    </Fragment>
                  ) : (
                    <Fragment >
                      <Label className={id !== undefined ? "" : "mt-3"}>
                        Price{' '}
                        <i
                          className="demo-icon simple-icon-info"
                          id="pricetip"
                        ></i>{' '}
                      </Label>
                      <Tooltip
                        placement="right"
                        isOpen={priceToolTip}
                        target="pricetip"
                        toggle={togglePriceToolTip}
                      >
                        You can chose your digital assistant to give customer a
                        single price.
                      </Tooltip>
                    </Fragment>
                  )}
                </div>
                <div className='d-none'>
                  {qbot === false ? (
                    <div className="row ">
                      {messengerData.type !== 'Retail' && messengerData.type !== 'InformationOnly' && messengerData.type !== "OpenProducts" && (
                        <Fragment>
                          <div className="col-5">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                $
                              </InputGroupAddon>
                              <Input
                                required
                                name="priceRangeStart"
                                type="number"
                                min="0"
                                value={messengerData.priceRangeStart}
                                onChange={handleChange}
                              />
                            </InputGroup>
                          </div>
                          <div className="col-2 mt-3">to</div>
                          <div className="col-5">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                $
                              </InputGroupAddon>
                              <Input
                                required
                                name="priceRangeEnd"
                                type="number"
                                min="0"
                                value={messengerData.priceRangeEnd}
                                onChange={handleChange}
                              />
                            </InputGroup>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  ) : isServiceOrder === true ? (
                    <div className="row">
                      <div className="col-5">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                          <Input
                            required
                            name="priceRangeStart"
                            type="number"
                            min="0"
                            value={messengerData.priceRangeStart}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </div>
                      <div className="col-2 mt-3">to</div>
                      <div className="col-5">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                          <Input
                            required
                            name="priceRangeEnd"
                            type="number"
                            min="0"
                            value={messengerData.priceRangeEnd}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </div>
                    </div>
                  ) : (
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                      <Input
                        required
                        name="priceRangeStart"
                        type="number"
                        min="0"
                        value={messengerData.priceRangeStart}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  )}
                </div>
                {isAccommodation === true && messengerData.type !== 'Retail' && messengerData.type !== 'InformationOnly' && messengerData.type !== "OpenProducts" && messengerData.type !== 'TitleAction' ? (
                  <Fragment>
                    <div className="row d-none">
                      <div className="col-12">
                        <Label className="mt-3"></Label>
                        <CustomInput
                          type="checkbox"
                          id="offerDiscount"
                          label="Offer Discount"
                          checked={messengerData.offerDiscount}
                          onChange={handleCheckedDiscount}
                        />
                      </div>
                    </div>
                  </Fragment>
                ) : (
                  isServiceOrder === true && (
                    <Fragment>
                      <div className="row d-none">
                        <div className="col-12">
                          <Label className="mt-3"></Label>
                          <CustomInput
                            type="checkbox"
                            id="offerDiscount"
                            label="Offer Discount"
                            checked={messengerData.offerDiscount}
                            onChange={handleCheckedDiscount}
                          />
                        </div>
                      </div>
                    </Fragment>
                  )
                )}
                {messengerData.offerDiscount && (
                  <div className="row d-none">
                    <div className="col-5">
                      <Label className="mt-3">Discount </Label>
                      <InputGroup>
                        <Input
                          required
                          name="discount"
                          type="number"
                          value={messengerData.discount}
                          onChange={handleChange}
                        />
                        <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                      </InputGroup>
                    </div>
                    <div className="col-7">
                      <Label className="mt-3">After Discount </Label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">$</InputGroupAddon>
                        <Input
                          disabled
                          name="afterDiscount"
                          type="text"
                          value={messengerData.discountedPrice}
                          onChange={handleChange}
                        />
                        <p style={{ padding: '10px', fontWeight: 'bold' }}>
                          to
                        </p>
                        <Input
                          disabled
                          name="afterToDiscount"
                          type="text"
                          value={messengerData.discountedPriceEnd}
                          onChange={handleChange}
                          style={{ height: '42px' }}
                        />
                      </InputGroup>
                    </div>
                  </div>
                )}
                <div className="d-none">
                  {messengerData.type !== 'Retail' && messengerData.type !== 'InformationOnly' && messengerData.type !== "OpenProducts" && (
                    <Fragment>
                      <Label className="mt-3 ">Tax Included in Price? </Label>
                      <Input
                        name="taxIncluded"
                        type="select"
                        onChange={handleChange}
                        value={messengerData.taxIncluded}
                      >
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </Input>
                    </Fragment>
                  )}
                </div>
                {/* {isAccommodation === true && messengerData.type !== "Retail" && (
                 <div className="row">
                   <div className="col-6">
                     <Label className="mt-3">Tax Percentage <span style={{ color: "red" }}>*</span></Label>
                     <InputGroup>
                       <Input
                         required
                         name="taxPercentage"
                         type="number"
                         min="0"
                         value={messengerData.taxPercentage}
                         onChange={handleChange}
                       />
                       <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                     </InputGroup>
                   </div>
                   <div className="col-6">
                     <Label className="mt-3">Tax Amount <span style={{ color: "red" }}>*</span></Label>
                     <Input
                       disabled
                       name="taxAmount"
                       type="text"
                       value={messengerData.taxAmount}
                       onChange={handleChange}
                       style={{ height: "42px" }}
                     />
                   </div>
                 </div>
               )} */}
                <div className="d-none" >
                  {messengerData.type !== 'Retail' && messengerData.type !== 'InformationOnly' && (
                    <Fragment >
                      <Label className="mt-3">Conditions & Terms</Label>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(messengerData.conditions)}
                        onChange={(content, delta, source) =>
                          handleChangeConditionsArr(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="conditions"
                      />
                    </Fragment>
                  )}
                </div>
                {isAccommodation === true && messengerData.type !== 'Retail' && messengerData.type !== 'InformationOnly' && messengerData.type !== "OpenProducts" && messengerData.type !== "OpenChatbot" && messengerData.type !== "OpenRooms" && (
                  <Fragment>
                    <Label className="mt-3">Action Type</Label>
                    <Input
                      type="select"
                      name="bookingMethod"
                      value={messengerData.bookingMethod}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="ExternalURL"> Open External URL</option>
                      {/* <option value="PromoCode">Promo Code</option>
                      <option value="aiva">aiva</option>
                      <option value="CreateTicket">Create Ticket (Pre Check-in)</option>
                      <option value="CreateTicketInStay">Create Ticket (In Stay)</option> 
                      <option value="TakePayment">Take Payment</option>*/}
                      <option value="SubmitForm">Open Form</option>
                      <option value="ConversationFlow"> Trigger Conversation Flow</option>
                    </Input>
                  </Fragment>
                )}
                {isServiceOrder === true && (
                  <Fragment>
                    <Label className="mt-3">Action Type</Label>
                    <Input
                      type="select"
                      name="bookingMethod"
                      value={messengerData.bookingMethod}
                      onChange={handleChange}
                    >
                      <option value="0">Select</option>
                      <option value="ExternalURL">External URL</option>
                      {/* <option value="PromoCode">Promo Code</option>
                      <option value="aiva">aiva</option>
                      <option value="CreateTicket">Create Ticket</option>
                      <option value="TakePayment">Take Payment</option> */}
                    </Input>
                  </Fragment>
                )}
                {messengerData.bookingMethod === 'PromoCode' && (
                  <div className="row">
                    <div className="col-12">
                      <Label className="mt-3">Promo Code</Label>
                      <Input
                        type="text"
                        onChange={handleChangeArr}
                        value={messengerData.promoCode[0].statement}
                        name="promoCode"
                        placeholder="Promo Code"
                      />
                    </div>
                    <div className="col-12">
                      <Label className="mt-3">External Link (Url)</Label>
                      <Input
                        type="text"
                        onChange={handleChangeArr}
                        value={messengerData.externalUrl[0].statement}
                        name="externalUrl"
                        placeholder="External Link (Url)"
                      />
                    </div>
                    <div className="col-12">
                      <Label className="mt-3">Instructions</Label>
                      <Input
                        type="textarea"
                        onChange={handleChangeArr}
                        value={messengerData.instructions[0].statement}
                        name="instructions"
                        placeholder="Instructions"
                      />
                    </div>
                  </div>
                )}
                {messengerData.bookingMethod === 'ExternalURL' && (
                  <div className="row">
                    <div className="col-12">
                      <Label className="mt-3">External Link (Url)</Label>
                      <Input
                        type="text"
                        onChange={handleChangeArr}
                        value={messengerData.externalUrl[0].statement}
                        name="externalUrl"
                        placeholder="External Link (Url)"
                      />
                    </div>
                    <div className="col-12">
                      <Label className="mt-3">Instructions</Label>
                      <Input
                        type="textarea"
                        onChange={handleChangeArr}
                        value={messengerData.instructions[0].statement}
                        name="instructions"
                        placeholder="Instructions"
                      />
                    </div>
                    <div className='col-12'>
                      <Label className="mt-3">Action Button Text</Label>
                      <Input
                        type="text"
                        value={getLocalStatement(messengerData.submitButtonText)}
                        onChange={handleChangeSubmitButtonText}
                        name="submitButtonText"
                        placeholder="Action Button Text"
                      />
                    </div>
                  </div>
                )}
                {messengerData.type !== 'InformationOnly' && messengerData.type !== "OpenProducts" && messengerData.type !== "OpenChatbot" && messengerData.type !== "OpenRooms" && messengerData.bookingMethod === 'SubmitForm' && messengerData.bookingMethod !== 'ExternalURL' && messengerData.bookingMethod !== 'ConversationFlow' ?
                  <Fragment>
                    <Label className="mt-3">Select Forms</Label>
                    <Input
                      type="select"
                      name="forms"
                      value={getFormName(messengerData.forms)}
                      onChange={handleChangeForm}
                    >
                      <option value="">Select</option>
                      {formsData && formsData.map((item, i) =>
                        <option value={item.id} key={i}>{item.name}</option>
                      )}
                    </Input>
                    {messengerData.forms.length > 0 &&
                      <Fragment>
                        <Label className="mt-3">Action Button Text</Label>
                        <Input
                          type="text"
                          value={getLocalStatement(messengerData.submitButtonText)}
                          onChange={handleChangeSubmitButtonText}
                          name="submitButtonText"
                          placeholder="Action Buttom Text"
                        />
                      </Fragment>
                    }
                  </Fragment>
                  : null}
                {messengerData.bookingMethod === 'ConversationFlow' ?
                  <Fragment>
                    <Label className="mt-3">Select Conversational Flow</Label>
                    <Input
                      type="select"
                      name="conversationFlow"
                      value={messengerData.conversationFlowId}
                      onChange={handleChangeConFlow}
                    >
                      <option value="">Select</option>
                      {conversationFlowList && conversationFlowList.map((item, i) =>
                        <option value={item.id} key={i}>{item.name}</option>
                      )}
                    </Input>
                  </Fragment> : null
                }
                <div className='d-none'>
                  {isHostedPage !== undefined && isHostedPage && (
                    <Fragment>
                      <Label className="mt-3">Hosted Service Url</Label>
                      <Input
                        type="text"
                        value={
                          isServiceOrder === true
                            ? process.env.REACT_APP_SERVICE_URL +
                            '/gshp?id=' +
                            messengerData.id
                            : process.env.REACT_APP_SERVICE_URL +
                            '/shp?id=' +
                            messengerData.id
                        }
                        name="directLink"
                        disabled={true}
                      />
                    </Fragment>
                  )}
                </div>
              </Fragment>
            )}
            {messengerData.type === 'aivaVoucher' ? null : (
              <Fragment>
                <div className='mb-2'>
                  <Label className="mt-3">Image</Label>
                  <div className="text-center form-control">
                    {messengerData.imageLink != '' ? (
                      <div className="thumbnail">
                        <img
                          className="list-thumbnail responsive border-0"
                          src={messengerData.imageLink}
                        />
                        <a
                          href="#/"
                          className="remove"
                          data-dz-remove
                          onClick={() => handleRemoveImage()}
                        >
                          {' '}
                          <i className="glyph-icon simple-icon-trash" />{' '}
                        </a>
                      </div>
                    ) : (
                      ''
                    )}


                  </div>
                  <Button
                    color="secondary"
                    className="mt-1 btn-sec"
                    onClick={togglegallery}
                  >
                    <IntlMessages id='dashboards.browsegallery' />
                  </Button>
                </div>
                <div className='mb-2'>
                  <Label className="mt-3">Icon</Label>
                  <div className="text-center form-control">
                    {messengerData.iconLink != '' ? (
                      <div className="thumbnail">
                        <img
                          className="list-thumbnail responsive border-0"
                          src={messengerData.iconLink}
                        />
                        <a
                          href="#/"
                          className="remove"
                          data-dz-remove
                          onClick={() => handleRemoveIcon()}
                        >
                          {' '}
                          <i className="glyph-icon simple-icon-trash" />{' '}
                        </a>
                      </div>
                    ) : (
                      ''
                    )}

                  </div>
                  <Button
                    color="secondary "
                    className="mt-1 btn-sec"
                    onClick={toggleSvgGallery}
                  >
                    Choose your icon
                  </Button>
                </div>
              </Fragment>
            )}
            <Appearance
              appearance={messengerData.appearance}
              handleAppearance={handleAppearance}
            ></Appearance>
            <div className="row">
              <div className="col-12" style={{ marginTop: "1.5rem", display: "flex", alignItems: "center" }}>
                <CustomInput
                  type="checkbox"
                  id="is_globel"
                  label="Make this item globel i.e visible across all properties"
                  checked={messengerData.isGlobal}
                  onChange={handleCheckedGlobal}
                /> <i className="demo-icon simple-icon-info" id="globeltip"></i>
                <Tooltip
                  placement="right"
                  isOpen={globelToolTip}
                  target="globeltip"
                  toggle={toggleGlobelToolTip}
                >
                  <p className='text-left'>
                    This item will be visible across all the properties in your group.
                    Any changes will reflect across all the properties where you are showing this item.
                    <br /><br />
                    You can change the status to “Inactive” at property level,
                    if you don’t want to show for a particular property.
                  </p>
                </Tooltip>
              </div>
            </div>
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          {id && (
            <Button color="danger" onClick={toggle}>
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={addTagModel}
        toggle={() => {
          setAddTagModel(!addTagModel);
        }}
      >
        <ModalHeader toggle={() => setAddTagModel(!addTagModel)}>
          {isCategoryTag ? "Category" : "Membership Group"} Tag
        </ModalHeader>
        <ModalBody>
          <div className="margin-0">
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => {
                setOwnTag(e.target.value);
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => handleCustomisationsTag(ownTag)}
          >
            Add
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              setAddTagModel(!addTagModel);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      {addCategoryTagModel && (
        <CategoryTag
          visible={addCategoryTagModel}
          toggle={() => setAddCategoryTagModel(!addCategoryTagModel)}
          handleOwnCategoryTag={id === undefined ? handleOwnCategoryTag : handleUpdateOwnCategoryTag}
          allCategoryData={allAddonCategoryData}
          isEdit={isEditCategory}
          propertyId={propertyId}
          languageCode={languageCode}
        ></CategoryTag>
      )}

      <Modal isOpen={errorModel.isVisible}
        toggle={() => {
          setErrorModel({ ...errorModel, isVisible: !errorModel.isVisible, msg: "" });
        }}
      >
        <ModalBody>
          <div className="margin-0">
            <p>{errorModel.msg}</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => setErrorModel({ ...errorModel, isVisible: !errorModel.isVisible, msg: "" })}
          >
            OK
          </Button>
        </ModalFooter>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
      {generateDeleteButton()}
      {ImageGalleryButton()}
      {IconGalleryButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, domains } = settings;
  return {
    propertyId,
    locale,
    domains,
  };
};

export default injectIntl(connect(mapStateToProps, {})(AddNewMessenger));
